import { config } from '../config/env';

/**
 * Servicio para descargar archivos a través de proxy del backend
 * Similar a cURL en PHP - oculta la URL real de S3 al cliente
 */
export const fileService = {
  getAuthToken(): string | null {
    return localStorage.getItem('access_token') || localStorage.getItem('token');
  },

  async fetchFileBlob(fileUrl: string): Promise<Blob> {
    const response = await fetch(
      `${config.apiBaseUrl}/files/download?url=${encodeURIComponent(fileUrl)}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${this.getAuthToken()}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error('No se pudo obtener el archivo para visualizar');
    }

    return response.blob();
  },

  async getViewableFileUrl(fileUrl: string): Promise<string> {
    const blob = await this.fetchFileBlob(fileUrl);
    return window.URL.createObjectURL(blob);
  },

  revokeViewableFileUrl(blobUrl?: string | null): void {
    if (blobUrl) {
      window.URL.revokeObjectURL(blobUrl);
    }
  },

  /**
   * Descarga un archivo a través del proxy del backend
   * El backend obtiene el archivo de S3 y lo sirve (como cURL)
   * @param fileUrl - URL del archivo en S3 (se envía al backend)
   * @param fileName - Nombre para el archivo descargado
   */
  async downloadFile(fileUrl: string, fileName: string): Promise<void> {
    try {
      // Convertir respuesta a blob desde proxy autenticado
      const blob = await this.fetchFileBlob(fileUrl);
      
      // Crear URL temporal del blob
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Crear enlace de descarga con nombre personalizado
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      
      // Limpiar recursos
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    } catch (error) {
      console.error('Error al descargar archivo:', error);
      throw error;
    }
  },
};
